import { memoize, capitalize as _capitalize } from 'lodash';

export const capitalize = () => {
  return memoize(_capitalize);
};



// WEBPACK FOOTER //
// ./src/filters/capitalize.js